<template>
  <div class="container">

    <!-- Hidden button to trigger modal -->
    <button type="button" class="collapse" id="UpdateOfficerModalButton" data-bs-toggle="modal" data-bs-target="#UpdateOfficerModal">
      Launch modal
    </button>

<!-- UpdateOfficerModal - Fixed for better layout -->
<div class="modal" id="UpdateOfficerModal" data-bs-backdrop="static">
  <div class="modal-dialog modal-fullscreen-xl-down modal-xl">
    <div class="modal-content" style="width: 95%; max-width: 1400px; margin: 0 auto;">
      <div class="modal-header">
        <h3>{{ selectedOfficerIdForModal ? 'Edit Officer' : 'Add New Officer' }}</h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="max-height: 80vh; overflow-y: auto;">
        <ProfileView 
          @saved="refreshOfficerList"
          :baseUrl="baseUrl"
          :officerId="selectedOfficerIdForModal"
          :isAddMode="!selectedOfficerIdForModal"
        />
      </div>
    </div>
  </div>
</div>


    <!-- Add a div overlay for popup effect -->
    <div v-if="showBankInfoCard" class="card-overlay">
      <div class="card-popup">
        <button class="close-popup" @click="closeBankInfoCard">×</button>
        <BankDetailView v-if="showBankInfoCard"
          :baseUrl="baseUrl"
          :officerIdValue="selectedOfficerIdForModal"
          @close="closeBankInfoCard"
          @saved="refreshOfficerList"
        />
      </div>
    </div>

    <!-- Add a div overlay for popup effect -->
    <div v-if="showUploadDocuments" class="card-overlay">
      <div class="card-popup">
        <button class="close-popup" @click="closeUploadDocuments">×</button>
        <UploadDocuments 
          v-if="showUploadDocuments"
          :baseUrl="baseUrl"
        />
      </div>
    </div>

    <!-- Speech Search -->
    <div class="speech-search-container">
      <div class="speech-search-wrapper">
        <button @click="toggleSpeechSearch" class="mic-btn" :class="{ recording: isListening }" :disabled="!isSpeechSupported">
          {{ isListening ? '⏹ Stop' : 'Speak 🎤' }}
        </button>
        <input type="text" v-model="searchString" placeholder="Search officers..." @keyup.enter="getSecurityOfficers(0)" />
        <!--button class="search-btn" @click="getSecurityOfficers(0)">🔍 Search</button-->
      </div>
      <div v-if="interimText && isListening" class="interim-text">🔴 {{ interimText }}</div>
    </div>

    <!-- Search and Add Button -->
    <div class="flex-container justify-content-ceter m-2">
      <input type="text" v-model="searchString" placeholder="Enter Search String">
      <input list="companiesList" v-model="selectedCompanyId" placeholder="Company">
      <datalist id="companiesList">
        <option v-for="company in companies" :key="company.companyId">
          {{company.companyId +"-"+ company.companyName}}
        </option>
      </datalist>
      <button type="button" class="btn btn-primary btn-sm m-2" @click="getSecurityOfficers(0)">Search</button>
      <button type="button" @click="OnAddOfficer" class="btn btn-primary btn-sm">Add Officer</button>
    </div>

    <!-- Auth Message -->
    <div>
      <span v-show="!isAuthorized" class="text-danger h2">Please make sure you are logged in.</span>
    </div>

    <!-- Officers Table -->
    <div class="row m-2">
      <table class="table text-left table-hover bg-white text-dark" v-show="isAuthorized">
        <thead>
          <tr>
            <th>Name</th>
            <th>Street Address</th>
            <th>Post Code</th>
            <th>City</th>
            <th>BankInfo</th>
            <th>Documents</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="officer in securityOfficers" :key="officer.securityOfficerId">
            <td>{{officer.name}}</td>
            <td>{{officer.streetAddress}}</td>
            <td>{{officer.postCode}}</td>
            <td>{{officer.cityName}}</td>
            <td @click="openBankInfoCard(officer)">Update</td>
            <td @click="openUploadDocuments(officer)">Manage</td>
            <td @click.stop="ShowUpdateOfficerModal(officer)">Edit</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="container mt-2">
      <button class="Btn btn-primary btn-sm m-1" v-show="isRangeLess_Than_TotalResultPages" @click="getSecurityOfficers(startPageNumber - LabelsPerPage)"> &lt;&lt;</button>
      <span v-if="endPageNumber > 1">
        <span v-for="pageNo in (endPageNumber)" :key="pageNo">
          <button class="btn btn-success btn-sm m-1" type="button" v-if="isShownPageButton(pageNo)" @click="getSecurityOfficers(pageNo -1)">{{ pageNo }}</button>
        </span>
        <button type="button" class="Btn btn-primary btn-sm m-1" v-show="isRangeGreater_Than_LabelsPerPage" @click="getSecurityOfficers(endPageNumber)"> >> </button>
      </span>
    </div>

  </div>
</template>

<script>
//import { Modal } from 'bootstrap';
import { computed } from 'vue';
import { IdDocument } from '../components/SecurityOfficer/IdDocument';
import { SecurityOfficer } from '../components/SecurityOfficer/SecurityOfficer';
import ProfileView from './Profile.vue'
import BankDetailView from './BankDetailView.vue'
import UploadDocuments from './UploadDocuments.vue'

export default ({
  name:'SecurityOfficers',
  components:{
    ProfileView,
    BankDetailView,
    UploadDocuments
  },
  props:{
      securityOfficerId:String,
      baseUrl:String,
  },
  data() {
      return{
          securityOfficers:[],
          modalContent:{},
          searchString:'',
          currentPageNo:0,
          startPageNumber : 1,
          endPageNumber:0,
          LabelsPerPage : 10,
          totalResultPages:0,
          totalRecordCount:0,
          recordsPerPage:10,
          isRangeGreater_Than_LabelsPerPage:false,
          isRangeLess_Than_TotalResultPages:false,
          isAuthorized:false,
          securityOfficerToAdd:null,
          securityOfficerObject:SecurityOfficer,
          IdDocumentInfo:IdDocument,
          companies:[],
          selectedCompanyId:"",
          cityList:[],
          tempOfficerObjectForCopying:SecurityOfficer,
          officerFullDetail:SecurityOfficer,
          isUpdateOfficerModalShown:false,
          isEntryMode:false,
          isNewOfficerToAdd:false,
          selectedCityName:'',
          selectedCityId:0,
          genderList :[],
          documentTypesList :[],
          nationalityList  :[],
          selectedGenderType:'Male',
          selectedNationality:'United Kingdom',
          selectedCountryOfBirth:'',
          selectedAddressCountry:'United Kingdom',
          selectedIdDocumentCountryOfIssueId:0,
          selectedIdDocumentCountryOfIssue:"",
          documentTypeId:0,
          selectedIdDocumentName:"",
          selectedIdDocumentTypeName:"",
          selectedOfficerIdForModal: null,
          showBankInfoCard: false,
          showUploadDocuments: false,
          // Speech search state
          isListening: false,
          isSpeechSupported: true,
          interimText: '',
          recognition: null,
      }
  },
      methods:{
        // ============ SPEECH SEARCH METHODS ============
        toggleSpeechSearch() {
          if (this.isListening) {
            this.stopSpeechSearch();
          } else {
            this.startSpeechSearch();
          }
        },

        startSpeechSearch() {
          if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
            this.isSpeechSupported = false;
            alert('Speech recognition is not supported in this browser. Please use Chrome or Edge.');
            return;
          }

          const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
          this.recognition = new SpeechRecognition();
          this.recognition.lang = 'en-US';
          this.recognition.interimResults = true;
          this.recognition.continuous = false;

          this.recognition.onresult = (event) => {
            let finalText = '';
            let interimText = '';
            for (let i = event.resultIndex; i < event.results.length; i++) {
              if (event.results[i].isFinal) {
                finalText += event.results[i][0].transcript;
              } else {
                interimText += event.results[i][0].transcript;
              }
            }
            if (finalText) {
              ////this.searchString = finalText;
              // Remove ALL spaces (for spelling mode) or keep as is
              // If you want to always remove spaces:
              //this.searchString = finalText.replace(/\s+/g, '');
              this.searchString = finalText.replace(/\s+/g, '').replace(/[.,;!?]$/, '');
              this.interimText = '';
              this.stopSpeechSearch();
              // Auto-search after speech
              this.getSecurityOfficers(0);
            } else if (interimText) {
              this.interimText = interimText;
            }
          };

          this.recognition.onerror = (event) => {
            console.error('Speech error:', event.error);
            this.stopSpeechSearch();
            if (event.error !== 'not-allowed') {
              alert('Speech recognition error: ' + event.error);
            }
          };

          this.recognition.onend = () => {
            this.stopSpeechSearch();
          };

          this.isListening = true;
          this.recognition.start();
        },

        stopSpeechSearch() {
          this.isListening = false;
          this.interimText = '';
          if (this.recognition) {
            try {
              this.recognition.stop();
            } catch (e) {
              // ignore
            }
            this.recognition = null;
          }
        },

        openBankInfoCard(officer) {
          localStorage.OfficerId = String(officer.securityOfficerId);
          this.selectedOfficerIdForModal = String(officer.securityOfficerId);
          this.showBankInfoCard = true;
        },
  
        openUploadDocuments(officer) {
          localStorage.OfficerId = String(officer.securityOfficerId);
          this.selectedOfficerIdForModal = String(officer.securityOfficerId);
          this.showUploadDocuments = true;
        },
  
        closeBankInfoCard() {
          this.showBankInfoCard = false;
          this.selectedOfficerIdForModal = null;
        },

        closeUploadDocuments() {
          this.showUploadDocuments = false;
          this.selectedOfficerIdForModal = null;
        },

        dateToYYYYMMDD (d){
          return (
            new Date(d)
              .toLocaleString()
              .substring(0, 10)
          );
        },

        onOfficerAdded() {
            this.getSecurityOfficers(0)
        },

        refreshOfficerList() {
          this.getSecurityOfficers(this.currentPageNo);
          setTimeout(() => {
            this.closeBankInfoCard();
            this.closeUploadDocuments();
        }, 500);
      },

        ShowUpdateOfficerModal(officer) {
          this.selectedOfficerIdForModal = String(officer.securityOfficerId);
          const modalButton = document.getElementById('UpdateOfficerModalButton');
          if (modalButton) {
            modalButton.click();
          }
        },
        
        OnAddOfficer() {
          this.selectedOfficerIdForModal = null;
          const modalButton = document.getElementById('UpdateOfficerModalButton');
          if (modalButton) {
            modalButton.click();
          }
        },
        ClearData(){
          this.securityOfficerObject = [];
        },
        getUtilityLists(){
            let requestUrl = this.baseUrl + "SecurityOfficers/GenderAndDocumentTypesAndNationalityList";
            let requestoptions = {
              method:"GET",
              headers:{
                "Authorization":"Bearer " + localStorage.token,
                "Content-Type":"application/json"
              },
            }

            fetch(requestUrl, requestoptions)
            .then( response => {
              let res = response.json();
              return res;
            })
            .then(  r => {
              this.genderList =r.utilityService.gendersList;
              this.documentTypesList =r.utilityService.documentTypesList;
              this.nationalityList = r.utilityService.nationalityList;
            });
          },

      getSecurityOfficers(pageNumber){
        this.currentPageNo = pageNumber;

        let companyId = 0; 
        if(this.selectedCompanyId != undefined)
          companyId = this.selectedCompanyId.substring(0, this.selectedCompanyId.indexOf("-"));

        var options = {
          method:'POST',
          headers:{
            'Authorization': `Bearer ${localStorage.token}`,
            'Content-Type':'application/json'
          },
          body:JSON.stringify({
            'PageNumber': this.currentPageNo,
            'RecordsPerPage':this.recordsPerPage,
            'SearchString': this.searchString,
            'CompanyId': parseInt(companyId)
          }),
      }

        const url = (this.baseUrl ?? this.smsapi_endpoint_base_url) + "securityofficers/securityofficers";
        fetch(url, options)
        .then(response => {
          var res = response.json()
          if(response.status == 401){
            this.isAuthorized = false;
            return null;
          }
          else{
            this.isAuthorized = true;
            return res;
        }
       })
       .then(result => {
            if(result == null)
            {
              this.schedule=null;
            }
            this.securityOfficers = result.officersListPage;
            this.totalRecordCount = result.totalRecordCount;
            this.recordsPerPage = result.pb.recordsPerPage;
            this.totalResultPages = (this.totalRecordCount % this.recordsPerPage == 0) ? this.totalRecordCount / this.recordsPerPage : this.totalRecordCount / this.recordsPerPage;
            this.totalResultPages = Math.ceil(this.totalResultPages);
            this.diplayResultPageList();
          }).catch(error=>{
              console.log("error encountered", error);
              return null;
          });

          this.securityOfficers=[]
          return this.securityOfficers;
       },
       isShownPageButton(pageNo){
       return (pageNo > this.startPageNumber) && (pageNo <= (this.startPageNumber + this.LabelsPerPage));
    },

      diplayResultPageList(){
      let sectionNo = Math.floor(this.currentPageNo/this.LabelsPerPage) ;
      this.startPageNumber = sectionNo * this.LabelsPerPage;
      this.endPageNumber = (sectionNo + 1) * this.LabelsPerPage;
      if (this.endPageNumber >= this.totalResultPages)
      {
          this.isRangeGreater_Than_LabelsPerPage = false;
          this.endPageNumber = this.totalResultPages;
      }
      else
      {
          this.isRangeGreater_Than_LabelsPerPage = true;
      }

      if(this.startPageNumber >= this.LabelsPerPage)
      {
        this.isRangeLess_Than_TotalResultPages = true;
      }
      else
      {
        this.isRangeLess_Than_TotalResultPages = false;
      }
  },
  ShowOfficerDetail(officerId){
    this.GetOfficerFullDetailById(officerId);
  },
getAuthorization(){
      var token = localStorage.getItem("token");
      if(token == "")
        this.isAuthorized = false;
      else
        this.isAuthorized=true;
    },
    getCompaniesList(){
      let clientsRequestUrl = this.baseUrl + "Companies/Companies";
      let clientsRequestOptions = {
        method:"GET",
        headers:{
          'Authorization': `Bearer ${localStorage.token}`,
            "Content-Type":"application/json",
        }
      };

      fetch(clientsRequestUrl, clientsRequestOptions)
      .then( response =>response.json())
      .then(reslt =>{
        this.companies = reslt;
      });
},
  },
  mounted(){
    this.getAuthorization();

    // Check speech support
    if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
      this.isSpeechSupported = false;
    }

    const updateOfficerDetailModalEl = document.getElementById('UpdateOfficerModal')
    updateOfficerDetailModalEl.addEventListener('shown.bs.modal', event => {
          this.isUpdateOfficerModalShown = true;
    });
    updateOfficerDetailModalEl.addEventListener('hidden.bs.modal', event => {
        this.isUpdateOfficerModalShown = false;
        this.isEntryMode = false;
        this.getSecurityOfficers(this.currentPageNo);
    });

    this.securityOfficerObject = new SecurityOfficer(0,'','','','',
            '','','',true,'','','','','','','','',''
            ,new Date(),'','','','',new Date(),'','',0,21,21,1,21,new IdDocument(1,new Date(),new Date(),1,''))

  },
  beforeMount(){
    this.getCompaniesList();
    this.getUtilityLists();
  },
  watch: {
      selectedOfficerIdForModal(newVal) {
      },
  },
})
</script>
<style scoped>
.card-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-popup {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
}

.close-popup {
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 1001;
}

/* Speech Search Styles */
.speech-search-container {
  margin-bottom: 10px;
}

.speech-search-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.speech-search-wrapper input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}

.speech-search-wrapper input:focus {
  border-color: #4a90d9;
}

.mic-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background: #4a90d9;
  color: white;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.3s;
}

.mic-btn:hover:not(:disabled) {
  background: #357abd;
}

.mic-btn.recording {
  background: #e74c3c;
  animation: pulse 1.5s infinite;
}

.mic-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.search-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 4px;
  background: #27ae60;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;
}

.search-btn:hover {
  background: #229954;
}

.interim-text {
  margin-top: 4px;
  padding: 4px 10px;
  background: #fff3cd;
  border-radius: 4px;
  color: #856404;
  font-size: 13px;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}
</style>